module.exports = __webpack_public_path__ + "static/media/mdpFinal.4f373fac.webp";